const getInitialFrom = (data, defaultGateway, previousSessionValue) => {
	if (!previousSessionValue) {
		return defaultGateway;
	}

	const dataSource = { ...data };

	if (data?.Regions?.length > 0) {
		// Force Canada region, if available
		const canadaRegion = data?.Regions.filter(region => region.Code === "CA");
		dataSource.Regions = canadaRegion || data?.Regions[0];
	}

	const previousSessionGateway = dataSource?.Regions?.[0]?.GatewayGroups.reduce(
		(foundGateways, curr) => {
			foundGateways.push(
				curr.Gateways.find(
					gateway =>
						gateway?.Code?.toUpperCase() ===
						previousSessionValue?.value?.toUpperCase()
				)
			);
			return foundGateways;
		},
		[]
	).filter(x => x);

	return {
		label: previousSessionGateway?.[0]?.Name ?? defaultGateway?.label,
		value: previousSessionGateway?.[0]?.Code ?? defaultGateway?.value
	};
};

export default getInitialFrom;
